export default __webpack_public_path__ + "static/media/waxp.683e074b.png";